<div class="container-fluid">
  <div class="col-xs-12">
    <div class="row">
      <div class="col-xs-12">
        <div class="modal-header">
          <h4 class="modal-title">Transplant Center Selection</h4>
        </div>
      </div>
    </div>
    <div class="col-xs-12">
      <div class="row">
        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table-striped table-bordered table-hover">
              <tbody>
                @for (item of cibmtrCenters; track item) {
                  <tr
                    (click)="selectRow(item)"
                    >
                    <td>
                      <input
                        name="center"
                        type="radio"
                        [value]="item"
                        [(ngModel)]="currentItem"
                        />
                    </td>
                    <td>{{ item.value }}</td>
                    <td>{{ item.name }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="col-12">
              <button
                type="button"
                class="btn btn-primary float-end buttonColor"
                (click)="onContinue()"
                >
                {{ "Continue" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
